<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M14.1183 2H3.10167C2.80949 2 2.52927 2.11607 2.32267 2.32267C2.11607 2.52927 2 2.80949 2 3.10167V6.9575C2 10.5875 3.75716 12.7874 5.23133 13.9937C6.8191 15.2923 8.39862 15.733 8.46747 15.7516C8.56215 15.7773 8.66198 15.7773 8.75666 15.7516C8.82551 15.733 10.403 15.2923 11.9928 13.9937C13.4628 12.7874 15.22 10.5875 15.22 6.9575V3.10167C15.22 2.80949 15.1039 2.52927 14.8973 2.32267C14.6907 2.11607 14.4105 2 14.1183 2ZM11.7553 6.79638L7.89943 10.6522C7.84827 10.7034 7.78752 10.7441 7.72065 10.7718C7.65378 10.7995 7.5821 10.8138 7.50971 10.8138C7.43732 10.8138 7.36564 10.7995 7.29877 10.7718C7.2319 10.7441 7.17115 10.7034 7.12 10.6522L5.4675 8.99971C5.36414 8.89636 5.30607 8.75617 5.30607 8.61C5.30607 8.46383 5.36414 8.32364 5.4675 8.22029C5.57085 8.11693 5.71104 8.05886 5.85721 8.05886C6.00338 8.05886 6.14357 8.11693 6.24692 8.22029L7.50833 9.48376L10.9745 6.01695C11.0256 5.96577 11.0864 5.92518 11.1533 5.89748C11.2201 5.86978 11.2918 5.85553 11.3642 5.85553C11.4365 5.85553 11.5082 5.86978 11.5751 5.89748C11.6419 5.92518 11.7027 5.96577 11.7539 6.01695C11.8051 6.06813 11.8457 6.12889 11.8734 6.19575C11.9011 6.26262 11.9153 6.33429 11.9153 6.40667C11.9153 6.47904 11.9011 6.55071 11.8734 6.61758C11.8457 6.68445 11.8051 6.7452 11.7539 6.79638H11.7553Z"
      fill="#D7DCE6"
    />
  </svg>
</template>

<script>
export default {
  name: 'PermissionsIconFilled18'
};
</script>

<style scoped>

</style>